export default "__VITE_ASSET__BscBBcHX__"